import { Box, ThemeProvider, Typography } from '@mui/material';
import React from 'react';
import { theme } from '../../../theme/theme';
import { Breadcrumb } from '../../Breadcrumb';
// import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { getDateRange } from '../../Filter/util';
import { walmartWeekMap } from '../../../constants/constant';
import CALENDARSVG from '../../../assets/SVGs/CalendarLight.svg';
import STORESVG from '../../../assets/SVGs/store.svg';
import { colors } from '../../../theme/color-palette';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';

const useStyles = makeStyles(() => ({
	hierarchyHeading: {
		fontSize: '24px',
		fontWeight: 700,
		lineHeight: '36px',
		textTransform: 'capitalize',
	},
	dateFilter: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: colors.LIGHT_GRAY_SHADE_1,
		padding: '4px 8px',
		borderRadius: '2px',
		gap: '4px',
	},
	dateFilterText: {
		'& .MuiTypography-root': {},
	},
	channelFilter: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: colors.LIGHT_GRAY_SHADE_1,
		padding: '4px 8px',
		borderRadius: '2px',
		gap: '4px',
		color: colors.DARK_GREY,
	},
	filters: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
	},
}));

const SubHeader = () => {
	const classes = useStyles();

	let {
		type,
		name, // Category || Department || Subcategory Name
		id, // Category || Department || Subcategory ID
	} = useParams();

	const selectedFilters = useSelector(
		(state) => state.salesReducer.selectedFilters
	);

	const sessionWeekFilters = JSON.parse(sessionStorage.getItem('weekfilters'));

	const { weekFilter, startWeek, endWeek, startDate, endDate } =
		sessionWeekFilters && Object.keys(sessionWeekFilters)?.length != 0
			? sessionWeekFilters
			: selectedFilters;

	const selectedFilter = 'Store';

	return (
		<ThemeProvider theme={theme}>
			<Box
				sx={{
					padding: '24px 32px',
					display: 'flex',
					flexDirection: 'column',
					gap: '16px',
				}}>
				<Breadcrumb />
				<Box>
					<Typography variant="bold" className={classes.hierarchyHeading}>
						{type?.toLocaleLowerCase()}: {id} {name?.toLocaleLowerCase()}
					</Typography>
				</Box>
				<Box className={classes.filters}>
					<Box className={classes.dateFilter}>
						<img src={CALENDARSVG} alt="Channel partner"></img>
						<Typography
							sx={{
								color: colors.DARK_GREY,
								fontSize: '12px',
								fontWeight: 400,
								lineHeight: '16px',
							}}>
							{'Time Range: '}
							{getDateRange(
								weekFilter,
								walmartWeekMap[weekFilter],
								startWeek,
								endWeek,
								moment(startDate),
								moment(endDate)
							)}
						</Typography>
					</Box>
					<Box>
						<Typography className={classes.channelFilter}>
							<img src={STORESVG} alt="STORE logo" />
							<Typography
								sx={{
									color: colors.DARK_GREY,
									fontSize: '12px',
									fontWeight: 400,
									lineHeight: '16px',
								}}>
								{'Channel: '}
								{selectedFilter}
							</Typography>
						</Typography>
					</Box>
				</Box>
			</Box>
		</ThemeProvider>
	);
};

export default SubHeader;
